"use client";

import Script from "next/script";

/*
 * strategy is 'lazyOnload', NOT 'worker'. next/script's worker strategy is a silent
 * no-op in the App Router: its loader effect only handles afterInteractive and
 * lazyOnload, and the worker branch needs the Pages-Router HeadManagerContext
 * (updateScripts/getIsSsr), which app/ never provides. Nothing is injected, nothing
 * is logged — the tag simply never runs. This script was dead in production from
 * #323 (Oct 2024) until it was switched back. Partytown being installed and
 * nextScriptWorkers being on does not change that. Do not set it back to 'worker'.
 */
export default function LiveChat() {

    return (
        <>
            <Script id="liveChatScript" strategy={'lazyOnload'}>
                {`
            window.__lc = window.__lc || {};
            window.__lc.license = 18240558;
            window.__lc.integration_name = "manual_channels";
            window.__lc.product_name = "livechat";
            ;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))
            `}
            </Script>
            <noscript><a href="https://www.livechat.com/chat-with/18240558/" rel="nofollow">Chat with us</a>, powered
                by <a
                    href="https://www.livechat.com/?welcome" rel="noopener nofollow" target="_blank">LiveChat</a>
            </noscript>

        </>
    );
}
